/* eslint-disable import/prefer-default-export */
import {resource} from '@albert-io/json-api-framework/request/builder';

export function getSchoolAccountsQuery(schoolId) {
  return resource('schools_v5')
    .mandarkEndpoint(['schools_v5', schoolId])
    .include('email_domains_v1')
    .include('classrooms_v1.students_v2,managed_users_v1.student_v2')
    .filter({
      included: {
        'classrooms_v1.students_v2': {
          'meta.is_active_managed_user': true
        },
        'managed_users_v1.student_v2': {
          'meta.is_active_managed_user': true
        }
      }
    })
    .customQuery({
      meta: {
        context: {
          school: {
            id: schoolId
          }
        }
      }
    })
    .withMeta('student_v2');
}
